<div class="pt-3">
	<footer class="footer">
		<main class="content mt-0 mb-2">
			<div class="container-fluid">
				<div class="row text-muted opacity-50">
					<!-- Footer Links -->
					<div class="col-12 col-md-8 text-start">
						<ul class="list-inline">
							<li
								class="list-inline-item me-4"
								*ngFor="let link of config.links"
							>
								<a
									class="text-muted"
									[href]="link.link"
									[target]="link.target ?? '_blank'"
								>
									{{ link.label }}
								</a>
							</li>
						</ul>
					</div>

					<!-- Copyright -->
					<div class="col-12 col-md-4 mt-2 mt-md-0 text-start text-md-end">
						<p class="mb-0">
							&copy; {{ CURRENT_YEAR }} -
							<a
								href="#"
								class="text-muted"
							>
								{{ config.company }}
							</a>
						</p>
					</div>
				</div>
			</div>
		</main>
	</footer>
</div>
